module.exports = __webpack_public_path__ + "img/redcross.69d6f7be.svg";